import { useState, useRef, useEffect } from "react";

export const useTooltip = () => {
  const [tooltip, setTooltip] = useState(null);
  const timeoutRef = useRef(null);
  const tooltipRef = useRef(null);

  const showTooltip = (event, text) => {
    const tooltipWidth = 200;
    const arrowOffset = 0;

    const top = event.clientY + window.scrollY - arrowOffset;
    const left = event.clientX + window.scrollX - tooltipWidth / 2;

    setTooltip({ text, position: { top, left } });

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setTooltip(null);
      timeoutRef.current = null;
    }, 5000);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setTooltip(null);
      }
    };

    // Добавляем небольшую задержку перед тем, как тултип сможет быть закрыт
    const delay = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(delay);
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [tooltip]);

  return { tooltip, showTooltip, tooltipRef };
};
